import { naturalScriptBoldFont, kristenFont, pdf, LoadingStatus, Globals } from "./commonExports";

import differenceInSeconds from "date-fns/differenceInSeconds";

const PAGE_MARGIN_WIDTH = 230;
const RIGHT_MARGIN_WIDTH = 180;

export const generateLearningJournalFromData = ({ observations, childData, school360_school_id, updateProgressFn, flags}) =>
{
    runReport({ school_id: school360_school_id, observations: observations, childData: childData, updateProgressFn: updateProgressFn, flags: flags } );
}

const loadImage = async (url, width, height) =>
{
    return new Promise((resolve, reject) =>
    {
        let img = new Image();

        img.addEventListener('load', e =>
        {

            var canvas = document.createElement('canvas');
            canvas.width = width; // or 'width' if you want a special/scaled size
            canvas.height = height; // or 'height' if you want a special/scaled size
            canvas.getContext('2d').drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, width, height);
            let dataURL = canvas.toDataURL();
            let res = canvas.toDataURL('image/png');
            let t = res.replace(/^data:image\/(png|jpg);base64,/, '');

            resolve({image: res, height: img.naturalHeight, width: img.naturalWidth});
        });

        img.addEventListener('error', () =>
        {
            reject(new Error(`Failed to load image's URL: ${url}`));
        });

        img.src = url;
    });
}

const getALDText = ( obs ) =>
{
    let text = '' ;

    text += obs.ald_1 === null ? '' : obs.ald_1 ;
    text += obs.ald_2 === null ? '' : obs.ald_2 ;
    text += obs.ald_3 === null ? '' : obs.ald_3 ;
    text += obs.ald_4 === null ? '' : obs.ald_4 ;
    text += obs.ald_5 === null ? '' : obs.ald_5 ;
    text += obs.ald_6 === null ? '' : obs.ald_6 ;
    text += obs.ald_7 === null ? '' : obs.ald_7 ;

    return text ;
}

const getALDTextArray = ( obs ) =>
{
    let rval = [] ;

    if ( obs.ald_1 !== null ) rval.push ( obs.ald_1 );
    if ( obs.ald_2 !== null ) rval.push ( obs.ald_2 );
    if ( obs.ald_3 !== null ) rval.push ( obs.ald_3 );
    if ( obs.ald_4 !== null ) rval.push ( obs.ald_4 );
    if ( obs.ald_5 !== null ) rval.push ( obs.ald_5 );
    if ( obs.ald_6 !== null ) rval.push ( obs.ald_6 );
    if ( obs.ald_7 !== null ) rval.push ( obs.ald_7 );

    return rval ;
}

const concatComma = ( value, add ) =>
{
    return value === '' ? value + add : value + ', ' + add ;
}

const getCOELText = ( obs ) =>
{
    let text = '' ;

    text = obs.coel_1 === '1' ? concatComma( text, 'Playing & Exploring' ) : text ;
    text = obs.coel_2 === '1' ? concatComma( text, 'Active Learning' ) : text ;
    text = obs.coel_3 === '1' ? concatComma( text, 'Creating & Thinking Critically' ) : text ;

    return text ;
}

const getCOELTextArray = ( obs ) =>
{
    let rval = [] ;

    if ( obs.coel_1 === '1' ) rval.push ( 'Playing & Exploring' );
    if ( obs.coel_2 === '1' ) rval.push ( 'Active Learning' );
    if ( obs.coel_3 === '1' ) rval.push ( 'Creating & Thinking Critically' );

    return rval ;
}

const getName = (obs) =>
{
    if ( obs.title === null || obs.title === '' )
    {
        return obs.forename + ' ' + obs.surname ;
    }
    else
    {
        return obs.title + ' ' + obs.surname ;
    }
}

const drawBorderBackground = () =>
{
    const borderColor = '#ecf8f9' ;

    const left = pdf.getDocWidth() - RIGHT_MARGIN_WIDTH ;

    // Draw the blue box
    pdf.drawRectangle( { x: left, y: 0, w: RIGHT_MARGIN_WIDTH, h: pdf.getDocHeight(), fillColor: borderColor})
}

const addNewPageWithBorder = async (obs) =>
{
    const name = getName(obs);

    const formattedDate = obs.formattedDate;
    const title = obs.observer_role;

    const capitalized =
        title.charAt(0).toUpperCase()
        + title.slice(1)

    pdf.addPage();

    const headerStyle = { fontSize: 8, fontStyle: 'bold', color: '#025D5E' };
    const textStyle = { fontSize: 8, fontStyle: 'bold', color: '#494A4B' };

    const overall = pdf.getDocWidth() ;
    const left = overall - RIGHT_MARGIN_WIDTH ;

    drawBorderBackground() ;

    const coels = getCOELTextArray(obs) ;

    let coelArray = [] ;

    if ( coels.length > 0 )
    {
        const coelFormats = coels.map((coel) =>
        {
            return {text: coel, style: textStyle} ;
        })

        coelArray = [ {text: 'COEL', style: headerStyle}, ...coelFormats ] ;
    }

    const alds = getALDTextArray(obs) ;

    let aldArray = [] ;

    if ( alds.length > 0 )
    {
        const aldFormats = alds.map((ald) =>
        {
            return {text: ald, style: textStyle} ;
        })

        coelArray = [ {text: 'Areas Of Learning', style: headerStyle}, ...aldFormats ] ;
    }

    if ( obs.includeALDs === false )
    {
        aldArray = [] ;
        coelArray = [] ;
    }

    const columnContent = {
        numberOfColumns: 1,
        absoluteColumnCoOrdinates: [ { left: left+ 20, width: RIGHT_MARGIN_WIDTH - 40 }],
        columnPadding: 20,
        leftMargin: left+20,
        rightMargin: left + RIGHT_MARGIN_WIDTH - 20 ,
        borderStyle: 'none',
        startY: 60,
        content: [
            [
                ...aldArray,
                ...coelArray,
                {text: '', style: textStyle},
                {text: 'Posted by ' + capitalized + ' ' + name, style: headerStyle},
                {text: formattedDate, style: textStyle},
            ],
        ]
    };

    const temp = pdf.getCurY() ;

    pdf.outputColumns(columnContent);

    pdf.setCurY( temp ) ;
}

const getObsTitle = (obs) =>
{
    const context = obs.context

    return [
        {text: context, style: {fontStyle: 'bold', fontSize: 12, color: '#CB4308'}},
    ]
}

const getObsWithHeaders = (obs) =>
{
    const context = obs.context
    const learning = obs.learning
    const next = obs.next
    let observation = obs.observation

    if ( observation !== null )
    {
        const o2 = observation.replace(/\r\n/g, "\n");
        const o3 = o2.replace(/\r/g, "\n");
        const o4 = o3.replace(/\n/g, "\r\n");

        observation = o4 ;
    }

    if ((learning !== null && next !== null))
    {
        if ( obs.includeDetailHeadings === true )
        {
            return [
                {text: ''},
                {text: context, style: {fontStyle: 'bold', fontSize: 12, color: '#CB4308'}},
                {text: ''},
                {text: 'What did I see and what did we do', style: {fontStyle: 'bold', fontSize: 10,}},
                {text: observation},
                {text: ''},
                {text: 'What is this telling me about your learning and development', style: {fontStyle: 'bold', fontSize: 10,}},
                {text: learning},
                {text: ''},
                {text: 'What next for learning in the setting and/or at home', style: {fontStyle: 'bold', fontSize: 10,}},
                {text: next},
            ]
        }
        else
        {
            return [
                {text: ''},
                {text: context, style: {fontStyle: 'bold', fontSize: 12, color: '#CB4308'}},
                {text: ''},
                {text: observation},
                {text: ''},
                {text: learning},
                {text: ''},
                {text: next},
            ]

        }
    }
    else
    {
        let obs_lines = [] ;

        if ( observation !== null )
        {
            if ( obs.includeDetailHeadings === true )
            {
                obs_lines =  [
                    {text: ''},
                    {text: 'What did I see and what did we do', style: {fontStyle: 'bold', fontSize: 10,}},
                    {text: observation}
                ];
            }
            else
            {
                obs_lines = [
                    {text: observation}
                ];
            }
        }

        return [
            {text: ''},
            {text: context, style: {fontStyle: 'bold', fontSize: 12, color: '#CB4308'}},
            ...obs_lines
        ]
    }
}

const outputHeader = (obs) =>
{
    const context = obs.context

    return [
        {text: context, style: {fontStyle: 'bold', fontSize: 12, color: '#CB4308'}},
    ]
}

const getChildName = (childData) =>
{
    return childData.firstname + ' ' + childData.surname;
}

const strDate = new Date();
const shortYear = (strDate.getFullYear()).toString();

const displaySingleImageObservation = async (school_id, obs, noImage) =>
{

    let img2 = null;

    if (noImage === true)
    {
        img2 = await loadImage('/admin/assets/libs/school360/images/noimage.jpeg', 400, 400);
    }
    else
    {
        const images = obs.image_array;

        const image1id = images[0].doc_id;
        const obsId = obs.obs_id;
        const params = '?school360_school_id=' + school_id + '&square=true&size=400';

        const url = Globals.APIFolder + '/observations/' + obsId + '/image/' + image1id + params

        img2 = await loadImage(url, 400, 400);
    }

    const columnContent2 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY(),
        content: [
            [
                {image: img2.image, width: 500, height: 500, rotation: 3},
            ],
        ]
    };

    pdf.outputColumns(columnContent2);

    const columnContent3 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY() + 20,
        postAddPage: drawBorderBackground,
        content: [
            [
                ...getObsWithHeaders(obs),
            ],
        ]
    };

    pdf.outputColumns(columnContent3);

}

const imageURL = ( obsId, imageId, school_id, res ) =>
{
    const params = '?school360_school_id=' + school_id + '&square=true&size=' + res ;

    const url = Globals.APIFolder + '/observations/' + obsId + '/image/' + imageId + params

    return url ;
}

const displayTwoImageObservation = async (school_id, obs) =>
{
    const images = obs.image_array;

    const obsId = obs.obs_id;

    const [ img2, img3 ] = await Promise.all([
        loadImage(imageURL ( obsId, images[0].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[1].doc_id, school_id, 400 ), 400, 400)
    ]);

    const columnContent3 = {
        numberOfColumns: 2,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY(),
        content: [
            [
                {image: img2.image, width: 500, height: 500, rotation: 3},
            ],
            [
                {image: img3.image, width: 450, height: 450, rotation: 357},
            ],
        ]
    };

    pdf.outputColumns(columnContent3);

    const columnContent4 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY() + 20,
        postAddPage: drawBorderBackground,
        content: [
            [
                ...getObsWithHeaders(obs),
            ],
        ]
    };

    pdf.outputColumns(columnContent4);
}

const displayThreeImageObservation = async (school_id, obs) =>
{
    const images = obs.image_array;
    const obsId = obs.obs_id;

    const [ img2, img3, img4 ] = await Promise.all([
        loadImage(imageURL ( obsId, images[0].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[1].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[2].doc_id, school_id, 400 ), 400, 400)
    ]);

    const columnContent4 = {
        numberOfColumns: 2,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY(),
        content: [

            [
                {image: img2.image, width: 500, height: 500, rotation: 3, align: 'center', margin: 20},
            ],
            [
                {image: img3.image, width: 500, height: 500, rotation: 358},
            ],
        ]
    };
    pdf.outputColumns(columnContent4);

    const columnContent5 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY() + 20,
        content: [
            [
                {image: img4.image, width: 500, height: 500, rotation: 2},
            ],
        ]
    };
    pdf.outputColumns(columnContent5);

    const columnContent6 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY() + 20,
        postAddPage: drawBorderBackground,
        content: [
            [
                ...getObsWithHeaders(obs),
            ],
        ]
    };

    pdf.outputColumns(columnContent6);
}
const displayFourImageObservation = async (school_id, obs) =>
{
    const images = obs.image_array;
    const obsId = obs.obs_id;

    const [ img2, img3, img4, img5 ] = await Promise.all([
        loadImage(imageURL ( obsId, images[0].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[1].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[2].doc_id, school_id, 400 ), 400, 400),
        loadImage(imageURL ( obsId, images[3].doc_id, school_id, 400 ), 400, 400)
    ]);

    const columnContent7 = {
        numberOfColumns: 2,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY(),
        content: [

            [
                {image: img2.image, width: 500, height: 500, rotation: 3, align: 'center', margin: 20},
            ],
            [
                {image: img3.image, width: 500, height: 500, rotation: 357},
            ],

        ]
    };
    pdf.outputColumns(columnContent7);


    const columnContent8 = {
        numberOfColumns: 2,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY() + 20,
        content: [
            [
                {image: img4.image, width: 500, height: 500, rotation: 3},
            ],
            [
                {image: img5.image, width: 500, height: 500, rotation: 357},
            ],
        ]
    };

    pdf.outputColumns(columnContent8);

    const columnContent9 = {
        numberOfColumns: 1,
        columnPadding: 20,
        rightMargin: PAGE_MARGIN_WIDTH, // Make space for the right hand panel
        borderStyle: 'none',
        startY: pdf.getCurY(),
        postAddPage: drawBorderBackground,
        content: [

            [
                ...getObsWithHeaders(obs),
            ]
        ]
    };
    pdf.outputColumns(columnContent9);

}


const runReport = async ({school_id, observations, childData, updateProgressFn, flags}) =>
{
    const doUpdate = ( status ) =>
    {
        if ( updateProgressFn !== undefined )
        {
            updateProgressFn ( status ) ;
        }
    }

    const requiredFonts = [
        {filename: 'naturalscriptbold-bold.ttf', fontName: 'naturalscriptbold', style: 'bold', base64Font: naturalScriptBoldFont},
        {filename: 'kristen.ttf', fontName: 'kristenNormal', style: 'normal', base64Font: kristenFont,},

    ]

    pdf.initialise({additionalFonts: '', baseline: 'top', lineHeightFactor: 1.7});

    const childName = getChildName(childData);

    const thisYear = (shortYear);

    const frontPageStyle = {
        fontSize: 10, fontStyle: 'bold', fontName: 'Helvetica', color: '#494A4B',
    }
    const childNameStyle ={
        fontSize: 36, fontStyle: 'bold', fontName: 'Helvetica', color: '#CB4308',
    }

    const ABS_ADDRESS_X_START = 155 ;
    const ABS_ADDRESS_Y_START = 350 ;

    const ABS_NAME_X_START = 280 ;
    const ABS_NAME_Y_START = 460 ;

    const ABS_SCHOOL_NAME_X_START = 60 ;
    const ABS_SCHOOL_NAME_Y_START = 750 ;

    const school_name = observations[0].school_name ;

    const template = {
        filename: '/style/images/seven360/learning-journal/front_page_bird_box2.png',
        fields:
            [
                {name: childName, x: ABS_ADDRESS_X_START, y: ABS_ADDRESS_Y_START, ...frontPageStyle, angle: 7},
                {name: school_name, x: ABS_ADDRESS_X_START + 3, y: ABS_ADDRESS_Y_START + 20, ...frontPageStyle, angle: 7},
                {name: 'Northumberland', x: ABS_ADDRESS_X_START + 5, y: ABS_ADDRESS_Y_START + 40, ...frontPageStyle, angle: 7},
                {name: childData.firstname + "'s", x: ABS_NAME_X_START - 10, y: ABS_NAME_Y_START - 10, ...childNameStyle, angle: 2},
                {name: school_name, x: ABS_SCHOOL_NAME_X_START, y: ABS_SCHOOL_NAME_Y_START, ...frontPageStyle, angle: 0},
                {name: 'Year' + ' ' + thisYear, x: ABS_SCHOOL_NAME_X_START, y: ABS_SCHOOL_NAME_Y_START + 25, ...frontPageStyle, angle: 0},
            ]
    }
    const img = await loadImage(template.filename, 1785, 2526,);

    pdf.insertBackgroundImage(img.image);

    const fields = template.fields;

    for (let index = 0; index < fields.length; ++index)
    {
        const element = fields[index];

        pdf.outputFormField(element.x, element.y, element.name, {
            angle: element.angle,
            fontSize: element.fontSize,
            fontStyle: element.fontStyle,
            fontName: element.fontName,
            color: element.color
        });

    }

    const startTime = new Date() ;
    let totalsecs = 0 ;

    const pageCount = observations.length ;

    updateProgressFn ( {status: LoadingStatus.START, pageCount: pageCount, pagesLoaded: 0}) ;

    for (let i = 0; i < pageCount; i++)
    {
        let pageStartTime = new Date() ;

        // Append the includeALDs flag so we can check it when rendering each page
        const curObs = { ...observations[i], includeALDs: flags.includeALDs ?? true, includeDetailHeadings: flags.includeDetailHeadings ?? true } ;

        const imageCount = curObs.image_array.length ;

        //Need to add a default on here that adds pages for observations that don't have an image. Maybe include the school360 logo instead?
        switch ( imageCount )
        {
            case 1:
                await addNewPageWithBorder(curObs);
                await displaySingleImageObservation(school_id, curObs, false);
                break ;
            case 2:
                await addNewPageWithBorder(curObs);
                await displayTwoImageObservation(school_id, curObs, false);
                break ;
            case 3:
                await addNewPageWithBorder(curObs);
                await displayThreeImageObservation(school_id, curObs, false);
                break ;
            case 4:
                await addNewPageWithBorder(curObs);
                await displayFourImageObservation(school_id, curObs, false);
                break ;
            default:
                await addNewPageWithBorder(curObs);
                await displaySingleImageObservation(school_id, curObs, true);
                break ;
        }

        let pageEndTime = new Date() ;

        const secs = differenceInSeconds(  pageEndTime, pageStartTime ) ;
        totalsecs = differenceInSeconds( pageEndTime, startTime ) ;

        updateProgressFn ( {status: LoadingStatus.RUNNING, pageCount:pageCount, pagesLoaded: Number(i+1), lastPageLoadTimeSeconds: secs, totalLoadTimeSeconds: totalsecs}) ;
    }

    updateProgressFn ( {status: LoadingStatus.COMPLETE, pageCount:pageCount, pagesLoaded: pageCount, lastPageLoadTimeSeconds: 0, totalLoadTimeSeconds: totalsecs}) ;

    pdf.lineFeed(2);

    pdf.stream();
}
